import { mapActions } from 'vuex'

import BaseModal from '../BaseModal'

import MainButton from '../atoms/MainButton'
import MainInput from '../atoms/MainInput'
import MainSelect from '../atoms/MainSelect'
import MainTextarea from '../atoms/MainTextarea'
import MainCheckbox from '../atoms/MainCheckbox'

export default {
	name		: 'ModalPointB',
	components	: {
		BaseModal,
		MainButton,
		MainInput,
		MainSelect,
		MainTextarea,
		MainCheckbox
	},
	props		: {
		isVisible	: Boolean,
		courseSlug	: {
			type	: String,
			default	: ''
		},
		courseId	: {
			type	: [Number, String],
			default	: null
		},
		packageId	: {
			type	: [Number, String],
			default	: null
		}
	},
	data() {
		return {
			form: {
				skillLevelAfter: 1,
				goalsAchieved: '',
				goalsExplanation: '',
				courseRating: 1,
				recommendationRating: 5,
				difficulties: [],
				difficultyOther: '',
				recommendations: '',
				futureTopics: '',
				allowContact: false,
				contactChannel: '',
				contactInfo: '',
				contactTime: []
			},
			isSubmitting: false,
			difficultyOptions: [
				{ value: 'time_schedule', label: 'Не вистачало часу / розклад не підходив' },
				{ value: 'too_complex', label: 'Матеріал був занадто складним' },
				{ value: 'too_basic', label: 'Матеріал був занадто базовим' },
				{ value: 'pace_fast', label: 'Темп занадто швидкий' },
				{ value: 'pace_slow', label: 'Темп занадто повільний' },
				{ value: 'hw_volume', label: 'ДЗ: забагато / занадто об\'ємні' },
				{ value: 'hw_criteria', label: 'ДЗ: незрозумілі критерії оцінювання' },
				{ value: 'hw_examples', label: 'ДЗ: бракувало прикладів/шаблонів' },
				{ value: 'support_slow', label: 'Підтримка: замало фідбеку або довго чекати відповідь' },
				{ value: 'technical', label: 'Технічні питання (відео/звук/платформа/доступи)' },
				{ value: 'motivation', label: 'Недостатньо мотивації' },
				{ value: 'other', label: 'Інше' }
			],
			contactChannelOptions: [
				{ value: 'telegram', label: 'Telegram' },
				{ value: 'phone', label: 'Телефон' },
				{ value: 'viber', label: 'Viber' },
				{ value: 'whatsapp', label: 'WhatsApp' },
				{ value: 'email', label: 'Email' }
			],
			timeOptions: [
				{ value: 'morning', label: 'Ранок' },
				{ value: 'day', label: 'День' },
				{ value: 'evening', label: 'Вечір' },
				{ value: 'weekdays', label: 'Будні' },
				{ value: 'weekends', label: 'Вихідні' }
			]
		}
	},
	computed	: {
		isFormValid() {
			const baseValid = this.form.goalsAchieved !== '' &&
			this.form.courseRating >= 1 &&
			this.form.recommendationRating >= 1
			
			// Якщо частково/ні досягли цілей - потрібне пояснення
			if ((this.form.goalsAchieved === 'partially' || this.form.goalsAchieved === 'no') && !this.form.goalsExplanation.trim()) {
				return false
			}
			
			// Якщо дозволили контакт - потрібні контактні дані
			if (this.form.allowContact) {
				if (!this.form.contactChannel || !this.form.contactInfo.trim()) {
					return false
				}
			}
			
			return baseValid
		},
		contactPlaceholder() {
			const placeholders = {
				telegram: '@username',
				phone	: '+380...',
				viber	: '+380...',
				whatsapp: '+380...',
				email	: 'email@example.com'
			}
			
			return placeholders[this.form.contactChannel] || 'Введіть контактні дані'
		}
	},
	methods		: {
		...mapActions('pointAB', {
			savePointB: 'SAVE_POINT_B',
		}),
		toggleDifficulty(value) {
			const index = this.form.difficulties.indexOf(value)
			
			if (index > -1) {
				this.form.difficulties.splice(index, 1)
			} else {
				this.form.difficulties.push(value)
			}
		},
		toggleContactTime(value) {
			const index = this.form.contactTime.indexOf(value)
			
			if (index > -1) {
				this.form.contactTime.splice(index, 1)
			} else {
				this.form.contactTime.push(value)
			}
		},
		async handleSubmit() {
			if (!this.isFormValid) return
			
			if (this.courseId == null || this.packageId == null) return
			
			this.isSubmitting = true
			
			try {
				this.$store.commit('pointAB/SET_POINT_B_DATA', this.form)
				
				await this.savePointB({
					courseId	: this.courseId,
					packageId	: this.packageId,
					courseSlug	: this.courseSlug,
				})
				
				this.$emit('completed')
			} catch (e) {
				// помилка в store / https
			} finally {
				this.isSubmitting = false
			}
		}
	}
}
